/* eslint-disable @typescript-eslint/no-deprecated */

import * as React from 'react'
import { roundDownNumberOfCompanies } from '../../utils/formatting/number'
import { Text } from '../../styles'

export const OrganizationsHeaderText: React.FC<{ companiesCount: number; industriesCount: number }> = ({
  companiesCount,
  industriesCount,
}) => (
  <Text>
    {'This pension fund is invested in at least '}
    <b>{roundDownNumberOfCompanies(companiesCount)} companies</b>, split across {industriesCount} different industries:
  </Text>
)
